import request, { downloadRequest } from './request'

const importFile = (url, file, strategy) => {
  const formData = new FormData()
  formData.append('file', file)
  if (strategy) formData.append('strategy', strategy)
  return request(url, formData)
}

export const login = data => request('/api/admin/auth/login', data)
export const updatePassword = data => request('/api/admin/auth/password/update', data)
export const uploadUrl = '/api/admin/file/upload'

export const listResources = data => request('/api/admin/resources/list', data)
export const detailResource = data => request('/api/admin/resources/detail', data)
export const saveResource = data => request('/api/admin/resources/save', data)
export const publishResource = data => request('/api/admin/resources/publish', data)
export const deleteResource = data => request('/api/admin/resources/delete', data)
export const downloadResourceImportTemplate = () => downloadRequest('/api/admin/resources/import/template')
export const previewResourceImport = file => importFile('/api/admin/resources/import/preview', file)
export const executeResourceImport = (file, strategy) => importFile('/api/admin/resources/import/execute', file, strategy)
export const exportResources = data => downloadRequest('/api/admin/resources/export', data)

export const listCompanies = data => request('/api/admin/companies/list', data)
export const detailCompany = data => request('/api/admin/companies/detail', data)
export const saveCompany = data => request('/api/admin/companies/save', data)
export const publishCompany = data => request('/api/admin/companies/publish', data)
export const deleteCompany = data => request('/api/admin/companies/delete', data)
export const downloadCompanyImportTemplate = () => downloadRequest('/api/admin/companies/import/template')
export const previewCompanyImport = file => importFile('/api/admin/companies/import/preview', file)
export const executeCompanyImport = (file, strategy) => importFile('/api/admin/companies/import/execute', file, strategy)
export const exportCompanies = data => downloadRequest('/api/admin/companies/export', data)

export const dashboardStats = data => request('/api/admin/dashboard/stats', data)
export const listFeedback = data => request('/api/admin/feedback/list', data)
export const updateFeedbackStatus = data => request('/api/admin/feedback/status/update', data)
export const deleteFeedback = data => request('/api/admin/feedback/delete', data)
export const batchDeleteFeedback = data => request('/api/admin/feedback/batch-delete', data)

export const listSpecialApplications = data => request('/api/admin/special-applications/list', data)
export const detailSpecialApplication = data => request('/api/admin/special-applications/detail', data)
export const updateSpecialApplicationStatus = data => request('/api/admin/special-applications/status/update', data)
export const deleteSpecialApplication = data => request('/api/admin/special-applications/delete', data)
export const batchDeleteSpecialApplications = data => request('/api/admin/special-applications/batch-delete', data)

export const listUsers = data => request('/api/admin/users/list', data)
export const detailUser = data => request('/api/admin/users/detail', data)
export const saveUser = data => request('/api/admin/users/save', data)
export const resetUserPassword = data => request('/api/admin/users/password/reset', data)
export const deleteUser = data => request('/api/admin/users/delete', data)
